import { SPARK_PHOTO_SLOTS } from '../../../../services/sparkSubmission';
import { MIN_SPARK_PHOTOS } from './spark.shared';

interface RefinementPhotosHeaderProps {
    /** Placed/total photo counts from the Photos step; null before it reports. */
    progress: { placed: number; total: number } | null;
}

/** Fixed sub-header above the scrolling photo-slot grid: instructions plus a
 *  progress meter that turns green once the Spark minimum is met. */
export function RefinementPhotosHeader({ progress }: RefinementPhotosHeaderProps) {
    const placed = progress?.placed ?? 0;
    const total = progress?.total ?? SPARK_PHOTO_SLOTS.length;
    const pct = total > 0 ? Math.round((placed / total) * 100) : 0;
    const meetsMinimum = placed >= MIN_SPARK_PHOTOS;
    return (
        <div className="flex items-start justify-between gap-4 px-6 py-3 border-b border-gray-200 bg-white flex-shrink-0">
            <p className="text-sm text-gray-600 min-w-0">
                Place the patient's photos into their positions. Slots auto-fill when a photo
                already has a known position.
            </p>
            <div className="flex flex-col items-end gap-1 flex-shrink-0">
                <div className="flex items-center gap-2.5">
                    <span className="text-xs font-semibold text-gray-600 whitespace-nowrap">
                        {placed} of {total} placed
                    </span>
                    <div className="w-28 h-1.5 rounded-full bg-gray-200 overflow-hidden">
                        <div
                            className={`h-full rounded-full transition-all duration-200 ${meetsMinimum ? 'bg-green-500' : 'bg-gray-900'}`}
                            style={{ width: `${pct}%` }}
                        />
                    </div>
                </div>
                <span
                    className={`text-[11px] whitespace-nowrap ${meetsMinimum ? 'text-green-600' : 'text-gray-400'}`}
                >
                    {meetsMinimum
                        ? `Minimum of ${MIN_SPARK_PHOTOS} photos met`
                        : `At least ${MIN_SPARK_PHOTOS} photos required to continue`}
                </span>
            </div>
        </div>
    );
}
